var _defs, _path, _path2, _circle, _circle2, _circle3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBroomWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 687.37 732.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "broom_white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M662.7,13.5,491.3,345.8c1,.3,2,.6,2.9.9a132.49,132.49,0,0,1,20.4,8.5,109,109,0,0,1,20.8,14.2L707.1,36.5a25,25,0,0,0-44.4-23Z",
    transform: "translate(-22.5 -0.03)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M96.6,629.7c27.2,24.6,60.7,46,99.4,63.6,65.4,29.8,122.9,38.6,125.4,39h.2a17.85,17.85,0,0,0,2.3.2h.6c68.8-2.2,122.4-25.2,159.4-68.1C532.5,607.9,550.1,523,546.6,450c-1-20.9-8.4-42.2-23-57.5-1.1-1.1-2.2-2.2-3.4-3.3a79.53,79.53,0,0,0-17-11.8,102.88,102.88,0,0,0-16.5-6.9,61.55,61.55,0,0,0-7.1-1.8,55,55,0,0,0-9.8-.9c-24.1,0-47.2,15.2-64.9,30.6-18.2,16-36.8,33.4-57.4,47.1-22.6,15-47.4,22.5-73.2,29.9-33.4,9.5-67.6,15.6-102.1,19.4a839.84,839.84,0,0,1-92.6,5.4c-12.3,0-24.5-.3-36.8-1-.7,0-1.4-.1-2.1-.1H39.5a17,17,0,0,0-16.1,22.5C37.4,562.1,62,598.5,96.6,629.7Z",
    transform: "translate(-22.5 -0.03)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 598.7,
    cy: 619.67,
    r: 40.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 512.2,
    cy: 711.57,
    r: 20.3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 622.1,
    cy: 706.97,
    r: 20.3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroomWhite);
export default __webpack_public_path__ + "static/media/broom_white.621d9e8a0b592894450cf81d182f9bbf.svg";
export { ForwardRef as ReactComponent };